import React, { useState, useRef, useEffect } from "react";
import appLogo from "../../../assets/appLogo.png";
import accountSide from "../../../assets/account_circle.png";
import { Menu } from "lucide-react";
import upload from '../../../assets/uploads.svg';
import "../../../styles/businessDashboardStyle.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaCaretDown } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import { MdGroups } from "react-icons/md";
import AccountSetting from "./AccountSetting";
import { getUserDetails } from "../../services/operations/profileAPI";
import FileUploadModal from "../Resumes/FileUploadModal";
import logout from "../../../assets/logout.png";
import { logoutApi } from "../../services/operations/authAPI";

const Header = ({ toggleSidebar }) => {

  const [showDropdown, setShowDropdown] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const navigate=useNavigate()

  const dispatch = useDispatch();
  const user = useSelector((state) => state.profile.user)
  const token = useSelector((state) => state.auth.token)
  const timeStamp = user.last_login



    const handleLogout = async () => {
      await dispatch(logoutApi(token, navigate));
    };



   const handleOpenModal = () => {
    setModalOpen(true);
  };


  const handleCloseModal = () => {
    setModalOpen(false);
  };


  const formatCurrentDate = () => {
    const date = new Date();

    const options = {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    return date.toLocaleDateString(undefined, options);
  };

  const handleOpenDropdown = () => {
    setShowDropdown((prev) => !prev);
  };


  const handleOpenAccount = () => {
    setShowAccountModal(true);
    setShowDropdown(false);
  };

  const handleCloseAccountModal = () => {
    setShowAccountModal(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef, buttonRef]);


  useEffect(() => {
    dispatch(getUserDetails(token));
  }, [])




  return (
    <nav className="navbar">
      <div className="navbar-left">
        <button className="hamburger-icon" onClick={toggleSidebar}>
          <Menu size={16} />
        </button>
        <img src={appLogo} alt="app-logo" style={{ width: "178px", height: "51px", cursor: "pointer" }} onClick={() => navigate("/business-dashboard")} />
      </div>
      <div className="navbar-right">
           <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
              <button className="upload-btn" onClick={handleOpenModal}>
                <img src={upload} alt="Upload" />
                <span>Upload</span>
              </button>
            </div>
        <button className="navbar-button-left">
          <span>{formatCurrentDate()}</span>
        </button>
        <button className="navbar-button-right" onClick={handleOpenDropdown} ref={buttonRef}>
          <img src={user?.profile_image} alt="account" />
          <span>{user?.business?.company_name}</span>
          <FaCaretDown className={`dropdown-arrow ${showDropdown ? "rotate" : ""}`} />
        </button>
        {showDropdown && (
          <div className="modal-dropdown" ref={dropdownRef}>
            <div className="dropdown-profile">
              <div className="profile-left">
                <img
                  src={user.profile_image}
                  alt="Profile"
                  className="profile-logo"
                  loading="lazy"
                />
              </div>
              <div className="profile-right">
                <p className="profile-name">{user.name}</p>
                <p className="profile-email">{user.email}</p>
                <p className="profile-desc" onClick={handleOpenAccount}>
                  Profile & Preferences
                </p>
              </div>
            </div>
            <ul className="profile-dropdown-menu">
              <p style={{ color: "gray", fontSize: "14px", marginBottom: "5px" }}>Account</p>
              <li style={{ fontSize: "14px" }}>{user?.business?.company_name}</li>
            </ul>
            {user?.roles?.some(role => role.name === "business-admin") &&
              (
                <div className="profile-dropdown-teams">
                  <MdGroups style={{ color: "gray" }} size={24} />
                  <span style={{ fontSize: "14px", cursor: "pointer" }} onClick={() => { navigate("/business-dashboard/my-teams") }}>Invite your team</span>
                </div>
              )}
              <div className="profile-dropdown-teams">
                  <img src={logout} style={{ color: "gray" }} size={22} />
                  <span style={{ fontSize: "14px", cursor: "pointer" }} onClick={handleLogout}>Logout</span>
                </div>

          </div>
        )}
      </div>
      {showAccountModal && <AccountSetting onClose={handleCloseAccountModal} isOpen={showAccountModal} />}
      <FileUploadModal fetchResumes={()=>{}} isOpen={isModalOpen} onClose={handleCloseModal} />
    </nav>
  );
};

export default Header;
